import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faArrowRight} from '@fortawesome/free-solid-svg-icons';

import {RegisterService} from '../../../services/register.service';
import {AuthService} from '../../../services/auth.service';

@Component({
    selector: 'app-select-register',
    imports: [CommonModule, FontAwesomeModule],
    templateUrl: './select-register.component.html',
    styleUrl: './select-register.component.css'
})
export class SelectRegisterComponent implements OnInit {
  registers: any[] = [];

  constructor(
    private registerService: RegisterService,
    private auth: AuthService,
    private router: Router,
    library: FaIconLibrary
  ) {
    library.addIcons(faArrowRight);
  }

  ngOnInit(): void {
    const roles = this.getUserRoles();
      if (this.auth.isSuperUser()) {
      this.router.navigate(['/dashboard']);
      return;
    }
    this.registerService.getRegisters(1, 200).subscribe({
      next: (res: any) => {
        const data = res?.results || [];
        this.registers = data.filter((item: any) => item.is_active);
      }
    });
  }

  private getUserRoles(): string[] {
    const userInfo = this.auth.getCurrentUserInfo();
    const role = userInfo?.role;
    if (Array.isArray(role)) {
      return role;
    }
    return role ? [role] : [];
  }

  openRegister(registerId: number): void {
    this.router.navigate([`/visitor-management/entry/${registerId}`]);
  }
}
